<template>
  <div class="loader" :class="{ hidden: !isLoading }">
    <div class="loader-logo">
      <i class="fas fa-home"></i>
      VISION HOUSE
    </div>
    <div class="loader-bar">
      <div class="loader-progress"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

const props = withDefaults(defineProps<{ isLoading?: boolean }>(), { isLoading: true })
const emit = defineEmits(['loaded'])

onMounted(() => {
  if (props.isLoading) {
    setTimeout(() => emit('loaded'), 2000)
  }
})
</script>

<style scoped>
.loader {
  position: fixed;
  inset: 0;
  background: var(--vh-azul-profundo);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  transition: opacity 0.8s ease, visibility 0.8s;
}
.loader.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
.loader-logo {
  font-family: 'League Spartan', sans-serif;
  font-size: 3rem;
  font-weight: 800;
  color: white;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.loader-logo i {
  color: var(--vh-dorado);
  font-size: 2.5rem;
  animation: pulseLoader 1.5s ease infinite;
}
@keyframes pulseLoader {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
}
.loader-bar {
  width: 200px;
  height: 4px;
  background: rgba(255,255,255,0.2);
  border-radius: 2px;
  overflow: hidden;
}
.loader-progress {
  width: 0%;
  height: 100%;
  background: var(--vh-dorado);
  border-radius: 2px;
  animation: loadProgress 2s ease forwards;
}
@keyframes loadProgress {
  0% { width: 0%; }
  50% { width: 70%; }
  100% { width: 100%; }
}
</style>
